(function ($) {
  window.onscroll = function () {
    scrollFunction();
  };
  function scrollFunction() {
    if (
      document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100
    ) {
      $("#header").addClass("shrink");
    } else {
      $("#header").removeClass("shrink");
    }
  }

  $(window).load(function () {});

  $(document).ready(function () {
    $(".header-slider-single").slick({
      dots: true,
      infinite: true,
      arrows: false,
      lazyLoad: "ondemand",
      autoplay: true,
      autoplaySpeed: 3500,
    });

    $(".header-slider-multi").slick({
      dots: true,
      infinite: true,
      slidesToShow: 3,
      autoplay: true,
      autoplaySpeed: 3500,
      lazyLoad: "ondemand",
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 834,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  });
})(jQuery);
